import { TranscriptCategories } from '../model/transcript-categories.model';

export function syncTranscriptIsOpen(
    categories: TranscriptCategories[],
    transcriptId: number,
    isOpen: boolean,
    expandParent?: boolean,
): TranscriptCategories[] {
    return categories.map((cat) => {
        const ts = cat.subCategories.some((e) =>
            e.transcripts.some((ee) => ee.transcriptId === transcriptId),
        );
        if (ts == null) {
            return cat;
        }
        let found = false;
        return {
            ...cat,
            subCategories: cat.subCategories.map((sub) => {
                return {
                    ...sub,
                    transcripts: sub.transcripts.map((ts) => {
                        if (ts.transcriptId === transcriptId) {
                            found = true;
                            return { ...ts, isOpen };
                        }
                        return ts;
                    }),
                };
            }),
            isOpen: found && expandParent === true ? true : cat.isOpen,
            implicitlyOpened: found && expandParent === true,
        };
    });
}
